import { Box, Typography as MuiTypography } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';

const PREFIX = 'MultiLegTitle';

const classes = {
  root: `${PREFIX}-root`,
  subtitle: `${PREFIX}-subtitle`,
};

const StyledCard = styled(Box)(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
  },
}));

const Typography = styled(MuiTypography)(({ theme }) => ({
  [`&.${classes.subtitle}`]: {
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '24px',
  },
}));

interface MultiLegTitleProps {
  legIndexReadable: number;
}

const MultiLegTitle = ({ legIndexReadable }: MultiLegTitleProps) => {
  const { t } = useTranslation('common');

  return (
    <StyledCard className={classes.root}>
      <Typography className={classes.subtitle}>
        {t('reservation.leg', { leg: legIndexReadable })}
      </Typography>
    </StyledCard>
  );
};

export { MultiLegTitle };
